<template>
<form action="">
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{$t('createNewTitle')}}</p>
    </header>
    <section class="modal-card-body">
      <b-field :label="$t('name')">
        <b-input ref='listName' type='text' v-model='listName' maxlength="50" required>
        </b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot fix-footer">
      <button class="button" @click="$parent.close()" type="button">{{$t('cancelButton')}}</button>

      <button :disabled="listName.trim() === ''"
        class="button is-primary"
        @click="save">{{$t('createButton')}}
      </button>
    </footer>
  </div>
</form>
</template>

<i18n src="../../i18n/ShoppingList.i18n.json"></i18n>

<script>
import i18nMixin from '@/mixins/i18n';
import routingMixin from '@/mixins/routing';
import { NEW_LIST, LISTS_QUERY } from '../../graphql/shopping-list';
import { getErrorMessage } from '../../utils/errors';

export default {
  name: 'shoppingListModalNew',
  data() {
    return {
      listName: '',
    };
  },
  mixins: [i18nMixin, routingMixin],
  mounted() {
    this.$refs.listName.focus();
  },
  methods: {
    save() {
      this.$apollo.mutate({
        mutation: NEW_LIST,
        variables: {
          name: this.listName.trim(),
        },
        refetchQueries: [{
          query: LISTS_QUERY,
        }],
      }).then(({ data: { shoppingListCreateNew } }) => {
        this.$emit('ok', shoppingListCreateNew);
        this.$parent.close();
      }).catch((err) => {
        this.$toast.open({
          message: getErrorMessage(err),
          type: 'is-danger',
        });

        this.$parent.close();
      });
    },
  },
};

</script>

<style lang="sass" scoped>
.fix-footer
  justify-content: flex-end

</style>



// WEBPACK FOOTER //
// src/components/shopping-list/ShoppingListModalNew.vue